import React, { useEffect } from 'react';
import './Toast.css';

function Toast({ message, isVisible, onClose, position = 'bottom-center' }) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000); // Auto-close after 5 seconds
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div className={`toast toast-${position}`}>
      <div className="toast-content">
        <p className="toast-message">{message}</p>
        <button className="toast-close" onClick={onClose} aria-label="Close">
          ×
        </button>
      </div>
    </div>
  );
}

export default Toast;




